interface Route {
  path: string
  step?: number
}

/**
 * Single source of truth for the funnel routes — the pages the user navigates
 * to via `router.push(ROUTES.x.path)`. Most carry a breadcrumb `step`.
 */
export const ROUTES = {
  petName: { path: "/quote/petName", step: 1 },
  petInfo: { path: "/quote/petInfo", step: 2 },
  petBreed: { path: "/quote/petBreed", step: 3 },
  petBirthdate: { path: "/quote/petBirthdate", step: 4 },
  petClaimHistory: { path: "/quote/petClaimHistory", step: 5 },
  tribe: { path: "/quote/tribe", step: 6 },
  attributionQuestion: { path: "/quote/attributionQuestion", step: 7 },
  userMailPhone: { path: "/quote/userMailPhone", step: 8 },
  tribeQuote: { path: "/quote/tribeQuote", step: 9 },
  coverage: { path: "/quote/coverage", step: 10 },
  userInformations: { path: "/quote/userInformations", step: 11 },
  userAddress: { path: "/quote/userAddress", step: 12 },
  userBirthInformations: { path: "/quote/userBirthInformations", step: 13 },
  recap: { path: "/quote/recap", step: 14 },
  payment: { path: "/quote/payment", step: 15 },
  healthCoverageParam: { path: "/quote/healthCoverageParam" },
  prepackages: { path: "/quote/prepackages" },
  pricing: { path: "/quote/pricing" },
} as const satisfies Record<string, Route>

/**
 * Path prefixes used only for "which area am I in?" checks
 * (`pathname.includes(...)` / `startsWith(...)`), never as `router.push` targets.
 * Kept separate from `ROUTES` because they are not single navigable destinations.
 */
export const ROUTE_PREFIXES = {
  pet: "/quote/pet",
  user: "/quote/user",
  welcome: "/welcome",
  redirect: "/redirect",
  landingPage: "/redirect/landing-page",
} as const

export const ROUTES_ARRAY: Route[] = Object.values(ROUTES)

export function getStepNumber(pathname: string) {
  const currentRoute = ROUTES_ARRAY.find(
    (route) => route.step !== undefined && pathname.includes(route.path)
  )
  return currentRoute?.step ?? 1
}
